export default "__VITE_PUBLIC_ASSET__5abfddca__"